import { Box } from "@mui/material";
import { type Ref, forwardRef } from "react";
import type { GridListProps } from "react-virtuoso";

export const GridVirtualizedSelectListContainer = forwardRef(function GridVirtualizedSelectListContainer(
  { children, ...props }: GridListProps,
  ref: Ref<unknown>
) {
  return (
    <Box
      {...props}
      ref={ref}
      sx={[
        {
          display: "flex",
          flexDirection: "row",
          flexWrap: "wrap",
          columnGap: 1,
        },
        () => ({ marginLeft: "-1px" }),
      ]}
    >
      {children}
    </Box>
  );
});
